'use strict';

angular.module('app').directive('seasonsPopup', function($http, $compile) {
    return {
        restrict: 'AE',
        scope: {
            seasonsPopup: '='
        },
        link: function(scope, elem) {
            $(elem).click(function() {
                $http.get('/templates/_seasons-popup.html').then(function(response) {
                    if (response.status == 200) {
                        var template = $compile(angular.element(response.data))(scope);

                        jQuery.fancybox({
                            content: template,
                            type: 'html',
                            maxWidth: '750px',
                            minWidth: '320px',
                            padding: 40,
                            wrapCSS: 'form-popup cancellation',
                            autoDimensions: false
                        });
                    }
                });
            });
        }
    };
});